<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="4"
        class="pa-0 mt-2"
      >
        <v-card>
          <v-card-title
            class="pb-0"
          >
            CI Suche
          </v-card-title>
          <v-card-text>
            <v-autocomplete
              v-model="current_ci_id"
              :items="$store.getters.get_cis_without_deleted"
              item-text="name"
              item-value="id"
              placeholder="Configuration Item"

              hide-details
              hint="Configuration Item"
              dense
              outlined
              single-line
              clearable
            >
            </v-autocomplete>
          </v-card-text>
        </v-card>
        <v-expand-transition
        >
          <v-card
            v-show="current_ci === null || !$store.getters.get_cis_without_deleted.includes(current_ci)"
            class="mt-2"
          >
            <v-card-title
              class="pb-0"
            >
              Neu erstellen
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="new_ci.name"
                class="mt-1"
                label="Name"
                dense
                outlined
                hide-details
              ></v-text-field>
              <v-select
                v-model="new_ci.type"
                :items="ci_types"
                item-text="name"
                item-value="type"
                class="mt-1"
                label="Typ"
                dense
                outlined
                hide-details
                @keydown.enter="create_ci"
              ></v-select>
              <v-card-actions
                class="pa-0 mt-1"
              >
                <v-spacer></v-spacer>
                <v-btn
                  class="primary"
                  :disabled="new_ci.name == null || new_ci.type == null"
                  @click="create_ci"
                >
                  Erstellen
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-expand-transition>
        <v-expand-transition
        >
          <v-card
            v-show="current_ci !== null && $store.getters.get_cis_without_deleted.includes(current_ci)"
            class="mt-2"
          >
            <v-card-title
              class="pb-0 mb-2 pr-2"
            >
              <v-text-field
                v-if="current_ci"
                v-model="current_ci.name"
                class="ci-name-input"
                hide-details
                dense
                flat
                solo
                background-color="transparent"
                :rules="[v => !!(v && v.trim()) || '']"
                @change="update_ci"
                @keydown.enter="$event.target.blur()"
              />
              <v-btn
                rounded
                x-small
                icon
                @click="current_ci_id = null"
              >
                <v-icon
                >
                  mdi-close
                </v-icon>
              </v-btn>
            </v-card-title>
            <v-card-subtitle
              class="pb-2"
            >
              <div class="d-flex align-center flex-wrap" style="gap: 4px;">
                <v-chip
                  v-if="ciTypeMeta"
                  x-small
                  label
                  outlined
                >
                  <v-icon left x-small>{{ ciTypeMeta.icon }}</v-icon>
                  {{ ciTypeMeta.label }}
                </v-chip>
                <v-chip
                  v-if="current_ci && current_ci.status"
                  x-small
                  label
                  :color="ciStatusMeta.color"
                  text-color="white"
                >
                  <v-icon left x-small>{{ ciStatusMeta.icon }}</v-icon>
                  {{ ciStatusMeta.label }}
                </v-chip>
              </div>
              <div
                v-if="parents.length"
                class="mt-2 d-flex align-center flex-wrap"
                style="gap: 4px;"
              >
                <span class="text-caption grey--text mr-1">Übergeordnet:</span>
                <v-chip
                  v-for="p in parents"
                  :key="p.id"
                  x-small
                  label
                  class="parent-chip"
                  :title="'Zu „' + p.name + '“ wechseln'"
                  @click="current_ci_id = p.id"
                >
                  <v-icon x-small left>mdi-arrow-up-bold-outline</v-icon>
                  {{ p.name }}
                </v-chip>
              </div>
              <div class="mt-2 text-caption grey--text">
                Erstellt: {{ formated_created_at }} · Aktualisiert: {{ formated_updated_at }}
              </div>
            </v-card-subtitle>
            <v-card-text
              v-if="current_ci !== null"
            >
              <v-autocomplete
                v-model="current_ci.owners"
                :items="users"
                label="Besitzer"
                item-text="displayName"
                item-value="id"
                multiple
                hide-details
                dense
                outlined
                chips
                small-chips
                :deletable-chips="current_ci.owners.length > 1"
                @change="update_ci"
              >
              </v-autocomplete>
              <v-textarea
                v-model="current_ci.description"
                class="mt-1"
                label="Beschreibung"
                dense
                outlined
                hide-details
                no-resize
                @change="update_ci"
              ></v-textarea>
              <div class="d-flex align-center mt-1">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="current_ci.revision_at"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-combobox
                      v-model="current_ci.revision_at"
                      label="Revisionsdatum"
                      prepend-inner-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      @click:clear="set_revision(null)"
                    ></v-combobox>
                  </template>
                  <v-date-picker
                    v-model="current_ci.revision_at"
                    no-title
                    scrollable
                    locale="de"
                    first-day-of-week="1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu = false"
                    >
                      Abbrechen
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="confirm_revision_pick"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                <v-btn
                  icon
                  class="ml-1"
                  title="Auf heute in 2 Jahren setzen"
                  @click="set_revision_in_2_years"
                >
                  <v-icon>mdi-calendar-arrow-right</v-icon>
                </v-btn>
              </div>
              <v-autocomplete
                v-model="current_ci.children"
                :items="children_candidates"
                class="mt-2 children-autocomplete"
                label="Untergeordnete CIs"
                item-text="name"
                item-value="id"
                multiple
                hide-details
                dense
                outlined
                @change="update_ci"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    v-if="index < children_chip_limit"
                    x-small
                    label
                    close
                    class="child-chip"
                    close-icon="mdi-close"
                    :title="item.name"
                    @click:close="remove_child(item.id)"
                  >
                    <span class="child-chip__label">{{ item.name }}</span>
                  </v-chip>
                  <span
                    v-else-if="index === children_chip_limit"
                    class="text-caption grey--text ml-1"
                  >
                    +{{ current_ci.children.length - children_chip_limit }} weitere
                  </span>
                </template>
              </v-autocomplete>
            </v-card-text>
            <v-card-actions
            >
              <v-spacer></v-spacer>
              <v-btn
                class="error"
                @click="delete_ci(current_ci)"
              >
                Löschen
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-expand-transition>

      </v-col>

      <v-col
        cols="8"
      >
        <v-expand-transition>
          <CIHistory
            v-show="current_ci_id !==null"
            :current_ci_id="current_ci_id"
            @switch-ci="current_ci_id = $event"
            @close="current_ci_id = null"
          ></CIHistory>
        </v-expand-transition>
        <v-expand-transition>
          <CIOverview
            v-show="current_ci_id === null"
            @select-ci="current_ci_id = $event"
          ></CIOverview>
        </v-expand-transition>

      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import CIHistory from "./CIHistory";
import CIOverview from "./CIOverview";
import { getCITypeMeta, getCIStatusMeta, CREATABLE_CI_TYPES } from "@/utils/ci_meta"
export default {
  name: "CITab",
  components: { CIHistory, CIOverview },
  props: {
    requested_ci_id: {
      type: Object,
      default: null,
    },
  },
  watch: {
    requested_ci_id: {
      handler(val){
        if (val && val.id != null) {
          this.current_ci_id = val.id
        }
      },
      immediate: true,
    },
    current_ci_id(val){
      this.$emit('ci-changed', val)
    },
  },
  data: () => ({
    current_ci_id: null,
    dates: '2018-09-15',
    menu: false,
    children_chip_limit: 4,

    new_ci: {
      name: null,
      type: null,
      description: '',
      tags: [],
      owners: [],
      children: [],
      created_at: null,
      updated_at: null,
      revision_at: null,
    },

    ci_types: CREATABLE_CI_TYPES,
  }),
  methods: {
    create_ci(){
      if(this.$store.state.user){
        this.new_ci.owners = [this.$store.state.user.id]
      }
      this.$store.dispatch("update", { payload_type: "POST", context: '/cis', payload: this.new_ci});
      this.new_ci.owners = []
      this.new_ci.name = null
      this.new_ci.type = null

    },
    update_ci(){
      if (!this.current_ci) return
      const name = (this.current_ci.name || "").trim()
      if (!name) return
      this.$store.dispatch("update", {
        payload_type: "PATCH",
        context: '/cis/' + this.current_ci.id,
        payload: {
          name,
          description: this.current_ci.description,
          owners: this.current_ci.owners,
          children: this.current_ci.children,
          revision_at: this.current_ci.revision_at,
        },
      })
    },
    log_message(message){
      const owners = this.$store.state.user ? [this.$store.state.user.id] : []
      this.$store.dispatch("update", {
        payload_type: "POST",
        context: '/cis/' + this.current_ci.id + '/log',
        payload: {
          ci_id: this.current_ci.id,
          owners,
          loglevel: 1,
          message,
          ticket_id: null,
        },
      })
    },
    format_revision_date(d){
      if (!d) return ''
      const date = new Date(d)
      return date.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    },
    set_revision(date){
      this.current_ci.revision_at = date
      this.update_ci()
      this.log_message(date
        ? `Revisionsdatum wurde auf ${this.format_revision_date(date)} gesetzt.`
        : 'Revisionsdatum wurde entfernt.')
    },
    set_revision_in_2_years(){
      const d = new Date()
      d.setFullYear(d.getFullYear() + 2)
      this.set_revision(d.toISOString().slice(0, 10))
    },
    confirm_revision_pick(){
      const date = this.current_ci.revision_at
      this.$refs.menu.save(date)
      this.set_revision(date)
    },
    remove_child(id){
      this.current_ci.children = this.current_ci.children.filter(c => c !== id)
      this.update_ci()
    },
    delete_ci(ci){
      this.$store.state.general.dialogs.push({title: 'CI löschen', text: 'Du bist dabei, das CI ' + ci.name +' zu löschen. Dieser Schritt kann nicht rückgängig gemacht werden. Alle Verknüpfungen werden aufgelöst. Bist du dir sicher?',  btn_1_title: 'Abbrechen', btn_2_title: 'Löschen', btn_2_update: { "payload_type": 'DELETE', "context": "/cis/" + ci.id}, btn_2_color: 'error', show: true})
    },
  },
  computed: {
    current_ci(){
      if(this.current_ci_id !== null){
        return this.$store.getters.get_ci(this.current_ci_id)
      }
      return null
    },
    users(){
      return this.$store.state.ticketsystem.users
    },
    children_candidates(){
      const all = this.$store.getters.get_cis_without_deleted
      if (!this.current_ci) return all
      return all.filter(c => c.id !== this.current_ci.id)
    },
    ciTypeMeta(){
      return getCITypeMeta(this.current_ci && this.current_ci.type)
    },
    ciStatusMeta(){
      return getCIStatusMeta(this.current_ci && this.current_ci.status)
    },
    parents(){
      if (!this.current_ci) return []
      const id = this.current_ci.id
      return this.$store.getters.get_cis_without_deleted
        .filter(ci => Array.isArray(ci.children) && ci.children.includes(id))
    },
    formated_updated_at(){
      if(!this.current_ci)
        return "--.--.---- 00:00:00"
      const date = new Date(this.current_ci.updated_at);
      return date.toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    formated_created_at() {
      if(!this.current_ci)
        return "--.--.---- 00:00:00"
      const date = new Date(this.current_ci.created_at);
      return date.toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
};
</script>

<style scoped>
.children-autocomplete >>> .v-select__selections {
  flex-wrap: wrap;
  gap: 4px;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.children-autocomplete >>> .v-select__selections input {
  flex: 1 1 60px;
  min-width: 60px;
}
.child-chip.v-chip {
  height: 22px !important;
  font-size: 0.72rem;
  letter-spacing: 0.2px;
  background: rgba(123, 0, 0, 0.08) !important;
  color: #7b0000 !important;
  border: none;
  padding: 0 6px;
  margin: 0 !important;
  max-width: 100%;
}
.child-chip >>> .v-chip__close {
  color: #7b0000 !important;
  opacity: 0.6;
  font-size: 14px !important;
  margin-left: 4px !important;
}
.child-chip >>> .v-chip__close:hover {
  opacity: 1;
}
.child-chip__label {
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.parent-chip.v-chip {
  height: 22px !important;
  font-size: 0.72rem;
  background: rgba(123, 0, 0, 0.08) !important;
  color: #7b0000 !important;
  border: none;
  cursor: pointer;
  transition: background 120ms ease-in-out;
}
.parent-chip.v-chip:hover {
  background: rgba(123, 0, 0, 0.16) !important;
}
.ci-name-input >>> .v-input__slot {
  padding: 0 8px !important;
  min-height: 36px !important;
  border-radius: 6px;
  transition: background 120ms ease-in-out;
}
.ci-name-input >>> input {
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
}
.ci-name-input >>> .v-input__slot:hover {
  background: rgba(0, 0, 0, 0.04) !important;
}
.ci-name-input.v-input--is-focused >>> .v-input__slot {
  background: rgba(123, 0, 0, 0.06) !important;
  outline: 1px solid rgba(123, 0, 0, 0.4);
}
</style>
